import {TICKETING_SYSTEM_MODULE_NAME_TO_MODULE_ID_MAPPER} from '@shared/constants/Mapping';
import {allPayersListOfGroup} from '@shared/services/InsuranceEligibilityServices';
import {getModuleTicketFields} from '@shared/services/WorkflowServices';
import {IModuleTicketFields} from '@shared/services/service-mappers/WorkflowMapper';
import {State} from '@shared/store/reducers/Index';
import {useSnackbar} from 'notistack';
import {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import {SnackBarConfig} from 'src/utils/SnackBarConfig';

interface IUseClaimsTicketsFieldsData {
  clinicGroupId: number | null;
}
const useClaimsTicketsFieldsData = ({
  clinicGroupId
}: IUseClaimsTicketsFieldsData): {
  customFields: IModuleTicketFields[];
  clinicPayersList: any[];
} => {
  const {selectedClinicId} = useSelector((state: State) => state.clinics);
  const {enqueueSnackbar} = useSnackbar();
  const {t} = useTranslation();
  const clinicId = selectedClinicId?.[0];
  const [customFields, setCustomFields] = useState<IModuleTicketFields[]>([]);
  const [customFieldOptions, setCustomFieldOptions] = useState<{
    clinicPayersList: any[];
  }>({
    clinicPayersList: []
  });

  const getPayersListOfGroup = async (): Promise<void> => {
    if (!clinicId || !clinicGroupId) {
      setCustomFieldOptions(prev => ({
        ...prev,
        clinicPayersList: []
      }));
      return;
    }
    try {
      const res = await allPayersListOfGroup(clinicGroupId);
      if (Array.isArray(res?.data?.rows)) {
        setCustomFieldOptions(prev => ({
          ...prev,
          clinicPayersList: res.data.rows
        }));
      } else {
        setCustomFieldOptions(prev => ({
          ...prev,
          clinicPayersList: []
        }));
      }
    } catch (error: any) {
      enqueueSnackbar(
        error?.message || t('CLINICS.CLINIC_GROUP_USER_ERROR'),
        SnackBarConfig('e')
      );
    }
  };

  useEffect(() => {
    getPayersListOfGroup();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clinicGroupId, clinicId]);

  useEffect(() => {
    const fetchModuleSpecificTicketFields = async () => {
      if (!clinicGroupId) return;
      try {
        const res = await getModuleTicketFields({
          clinic_group_id: clinicGroupId,
          params: {
            module:
              TICKETING_SYSTEM_MODULE_NAME_TO_MODULE_ID_MAPPER['CLAIMS_TICKETS']
          }
        });
        if (res.data) {
          setCustomFields(res.data);
        } else {
          setCustomFields([]);
        }
      } catch (error: any) {
        enqueueSnackbar(error?.message, SnackBarConfig('e'));
        setCustomFields([]);
      }
    };
    fetchModuleSpecificTicketFields();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clinicGroupId]);

  return {...customFieldOptions, customFields};
};

export default useClaimsTicketsFieldsData;
